module.exports = __webpack_public_path__ + "static/profile-e37be4b95f8f13298b90691263d8bee9.png";